import { ProviderPortalSentry } from '@vs/components/portal-sentry';
import { ProviderOidc } from '@vs/oidc-client';
import { TableActionStateProvider } from '@vs/shared-context/table-action-state-provider';
import { LocalizationProvider } from '@vs/ui/portal/time-picker';
import { ProviderEnv } from '@vs/utils/envConfig';
import { ProviderMuiTheme } from '@vs/utils/mui';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { deployEnv, isLocalDevMode } from '../constants';
import { env } from '../constants/env';
import { oidcConfig } from '../constants/oidc';
import { store } from '../redux/store';
import AppAuthRoutes from './appContent/AppAuthRoutes';

export default function App() {
  return (
    <ProviderEnv env={env}>
      <Provider store={store}>
        <ProviderMuiTheme>
          <ProviderOidc config={oidcConfig}>
            <ProviderPortalSentry
              enableSentry={!isLocalDevMode}
              sentryOptions={{
                env: deployEnv,
                tracesSampleRate: 0,
                replaysSessionSampleRate: 0,
              }}
              dialogMode="detail"
            >
              <DndProvider backend={HTML5Backend}>
                <BrowserRouter>
                  <TableActionStateProvider>
                    <LocalizationProvider>
                      <AppAuthRoutes />
                    </LocalizationProvider>
                  </TableActionStateProvider>
                </BrowserRouter>
              </DndProvider>
            </ProviderPortalSentry>
          </ProviderOidc>
        </ProviderMuiTheme>
      </Provider>
    </ProviderEnv>
  );
}
